import '../styles/blogpost.css';

const BlogPost = ({ title, url,CNTitle }) => {
    return (
        <div className="blog-post">
            <a href={url} target="_blank" rel="noopener noreferrer" className="blog-link">
                <h3 className="blog-title">{title}</h3>
                <h3 className="blog-title">{CNTitle}</h3>
            </a>
        </div>
    );
};

export default BlogPost;